import { isContentType } from "frontend/contentful/lib/is-content-type";
import {
  OrganizationEntry,
  PersonEntry,
  PersonWrapperEntry,
} from "frontend/contentful/schema/semantics";
import { ContentfulIncludes, EntryRef } from "../schema/sys";
import { resolveEntry } from "./resolve-includes";

interface ResolvePersonNameArgs {
  entry?: EntryRef<PersonEntry | PersonWrapperEntry | OrganizationEntry>;
  includes: ContentfulIncludes;
}

export function resolveEntityName({
  entry,
  includes,
}: ResolvePersonNameArgs): string {
  if (!entry) return "";

  let entity = resolveEntry(includes, entry);

  if (!entity) return "";

  // Handle PersonWrapperEntry
  if (isContentType<PersonWrapperEntry>("personWrapper", entity)) {
    if (entity.fields.displayName) {
      return entity.fields.displayName;
    }
    entity = resolveEntry(includes, entity.fields.person);
  }

  // Handle OrganizationEntry
  if (isContentType<OrganizationEntry>("organization", entity)) {
    return entity.fields.title || "";
  }

  // Handle generic PersonEntry
  if (entity?.fields.displayName) return entity.fields.displayName;

  // Construct full name for PersonEntry
  const { firstName, middleName, lastName, nameSuffix } = entity?.fields || {};

  return (
    [firstName, middleName, lastName, nameSuffix]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+,/g, ",") || ""
  );
}
